import { render, staticRenderFns } from "./CategoryDisplay.vue?vue&type=template&id=59c01b8a&"
import script from "./CategoryDisplay.vue?vue&type=script&lang=ts&"
export * from "./CategoryDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports